import { useRef, useState } from "react";
import Slider from "react-slick";
import { Box, Card, IconButton } from "@mui/material";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { PlayArrow, Pause, ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import ImageWithLoader from "../../../components/common/ImageWithLoader";
import useResponsive from "../../../hooks/useResponsive";

const images = [
    "images/partner/aapke-sarakar.png",
    "images/partner/charity-maharashtra-logo.png",
    "images/partner/cm-relief-fund-logo.png",
    "images/partner/india-gov-in.png",
    "images/partner/maharatra-sasan.png",
    "images/partner/mjpjay-logo.png",
    "images/partner/my-gov.png",
    "images/partner/pmnrf-logo.png",
    "images/partner/RBSK-logo.png",
];

const PartnerSlider = () => {
    const sliderRef = useRef<Slider | null>(null);

    const settings = {
        dots: false,
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [
            {
                breakpoint: 1200,
                settings: { slidesToShow: 4 }
            },
            {
                breakpoint: 960,
                settings: { slidesToShow: 3 }
            },
            {
                breakpoint: 600,
                settings: { slidesToShow: 2 }
            }
        ],
        prevArrow: <CustomPrevArrow />,
        nextArrow: <CustomNextArrow />
    };


    return (
        <Card elevation={3} sx={{ p: 3, borderRadius: 3 }}>
            <Box
                sx={{
                    width: "100%",
                    position: "relative",
                    "&:hover .nav-btn": {
                        opacity: 1,
                        visibility: "visible"
                    }
                }}
            >

             
                {/* Slider */}
                <Slider ref={sliderRef} {...settings} className="partnerSlider">
                    {images.map((src, index) => (
                        <Box
                            key={index}
                            sx={{
                                px: 1,
                                display: "flex",
                                justifyContent: "center",
                            }}
                        >
                            <ImageWithLoader
                                src={src}
                                alt={`Slide ${index + 1}`}
                                style={{
                                    height: 60,
                                    width: "auto",
                                    objectFit: "contain",
                                    transition: "0.3s",
                                    cursor: "pointer"
                                }}
                            // className="partner-img"
                            />
                        </Box>
                    ))}
                </Slider>
            </Box>
        </Card>
    );
};

const CustomPrevArrow = ({ onClick }: any) => (
    <IconButton
        className="nav-btn"
        onClick={onClick}
        sx={{
            position: "absolute",
            left: 10,
            top: "50%",
            transform: "translateY(-50%)",
            zIndex: 10,
            bgcolor: "white",
            boxShadow: 2,
            opacity: 0,
            visibility: "hidden",
            transition: "0.3s ease",
            "&:hover": { bgcolor: "grey.100" }
        }}
    >
        <ArrowBackIos fontSize="small" />
    </IconButton>
);

const CustomNextArrow = ({ onClick }: any) => (
    <IconButton
        className="nav-btn"
        onClick={onClick}
        sx={{
            position: "absolute",
            right: 10,
            top: "50%",
            transform: "translateY(-50%)",
            zIndex: 10,
            bgcolor: "white",
            boxShadow: 2,
            opacity: 0,
            visibility: "hidden",
            transition: "0.3s ease",
            "&:hover": { bgcolor: "grey.100" }
        }}
    >
        <ArrowForwardIos fontSize="small" />
    </IconButton>
);

export default PartnerSlider;
